export default __webpack_public_path__ + "static/gcn-responsive-animation-66292278aa0b21504457888ad9e41f51.mp4";